export const CONNECTION_TYPE = {
  wifi: "wifi",
  ethernet: "ethernet",
};

export const IP_METHOD = {
  dhcp: "auto",
  static: "manual",
};

export const CONNECTION_TYPE_OPTIONS = [
  { label: "WiFi", value: CONNECTION_TYPE.wifi },
  { label: "Ethernet", value: CONNECTION_TYPE.ethernet },
];

export const IP_METHOD_OPTIONS = [
  { label: "Automatic (DHCP)", value: IP_METHOD.dhcp },
  { label: "Manual (Static)", value: IP_METHOD.static },
];
